import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["skip"];
import { useGetRecommendationsQuery } from '../../../../__generated__/chirp/com/hubspot/academy/recommendations/rpc/ranked/RankedRecommendationService.hooks';
export const useRankedRecommendations = _ref => {
  let {
      skip
    } = _ref,
    variables = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    data,
    loading,
    error
  } = useGetRecommendationsQuery({
    skip,
    variables
  });
  return {
    rankedRecommendations: data === null || data === void 0 ? void 0 : data.results,
    correlationId: data === null || data === void 0 ? void 0 : data.correlationId,
    rankedRecommendationsLoading: loading,
    rankedRecommendationsError: error,
    rankedRecommendationsData: data
  };
};